import GenericCrudPage from "./GenericCrudPage";

const DEPTS = ["operations", "engineering", "accounts", "hr", "safety", "quality"].map((v) => ({
  value: v, label: v.charAt(0).toUpperCase() + v.slice(1),
}));

const STATUS = [
  { value: "active", label: "Active" },
  { value: "on_leave", label: "On Leave" },
  { value: "terminated", label: "Terminated" },
];

export default function EmployeesPage() {
  return (
    <GenericCrudPage
      testid="employees"
      overline="HR"
      title="Employees"
      description="Staff, engineers and site workforce records."
      endpoint="/employees"
      defaults={{ name: "", designation: "", department: "operations", phone: "", email: "", join_date: "", salary: 0, status: "active" }}
      fields={[
        { name: "name", label: "Name", type: "text" },
        { name: "designation", label: "Designation", type: "text" },
        { name: "department", label: "Department", type: "select", options: DEPTS },
        { name: "status", label: "Status", type: "select", options: STATUS },
        { name: "phone", label: "Phone", type: "text" },
        { name: "email", label: "Email", type: "text" },
        { name: "join_date", label: "Join Date", type: "date" },
        { name: "salary", label: "Salary (₹)", type: "number" },
      ]}
      columns={["name", "designation", "department", "phone", "salary", "status"]}
    />
  );
}
